import type { MouseEvent } from 'react';
import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

import type { TrackingContentType } from 'src/types/TrackingContext';

// The hero carousel always sits at the top of the page, so its content position is always 1.
const HERO_CAROUSEL_CONTENT_POSITION = '1';

type HeroCarouselClickType = 'cta click' | 'image click';

interface HeroCarouselImpressionContext {
  name: string;
  selectedPosition?: number;
  totalOptions: number;
  trackingContentType: TrackingContentType;
}

interface HeroCarouselClickContext extends HeroCarouselImpressionContext {
  clickType: HeroCarouselClickType;
}

export const trackHeroCarouselImpression = ({
  name,
  totalOptions,
  trackingContentType,
}: HeroCarouselImpressionContext) => {
  sendGAEvent({
    event: 'custom_event',
    event_action: 'Impression',
    event_category: `${HERO_CAROUSEL_CONTENT_POSITION} | ${trackingContentType}`,
    event_name: 'view_content',
    content_position: HERO_CAROUSEL_CONTENT_POSITION,
    content_type: `${trackingContentType}|${name}`.toLowerCase(),
    item_id: name.toLowerCase(),
    total_options: `${totalOptions}`,
  });
};

export const trackHeroCarouselClick = (
  e: MouseEvent<HTMLAnchorElement>,
  {
    clickType,
    name,
    selectedPosition,
    totalOptions,
    trackingContentType,
  }: HeroCarouselClickContext,
) => {
  sendGALinkClickEvent(e, {
    event: 'custom_event',
    event_action: clickType,
    event_category: `${HERO_CAROUSEL_CONTENT_POSITION} | ${trackingContentType}`,
    event_name: 'select_content',
    event_details: clickType,
    content_position: HERO_CAROUSEL_CONTENT_POSITION,
    content_type: `${trackingContentType}|${name}`.toLowerCase(),
    destination_URL: e.currentTarget.href,
    item_id: name.toLowerCase(),
    total_options: `${totalOptions}`,
    selected_position: `${selectedPosition}`,
  });
};
